import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, tap } from "rxjs";
import { CompanyRouteService } from './company-route.service';

@Injectable()
export class CompanyRouteGuardService implements CanActivate {

  constructor(
    public service: CompanyRouteService,
    public router: Router,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    let companyId = route.params['id'] as number;
    return this.service.isCompanyIdValid(companyId)
      .pipe(
        tap(valid => {
          if (!valid) {
            this.router.navigate(['']);
          }
        })
      );
  }
}
